import { FC } from 'react';
import { AllieAlertCircleOutlineIcon } from '../../../../styling/icons';
import { TypesCell } from '../utils/enums';
import { TypeCell } from '../TimeGrid.types';

interface IconWithoutReasonProps {
  type?: TypeCell;
  isNewId: boolean;
  reason?: string;
  count?: number;
}

export const IconWithoutReason: FC<IconWithoutReasonProps> = ({ type, reason, isNewId, count }) => {
  if (
    reason ||
    !isNewId ||
    ![TypesCell.PLANNED_STOP, TypesCell.UNPLANNED_STOP]
      .includes(type as TypesCell)
  ) {
    return null;
  }

  return (
    <AllieAlertCircleOutlineIcon
      className={
        `icon-without-reason icon-without-reason--${type}
        ${count === 1 ? 'icon-without-reason--single' : ''}`
      }
    />
  );
};
